import React, { useState } from 'react';
import Icon from '../../components/Icon/Icon';
import CreationTable from '../../components/CreationTable/CreationTable';
import './Admin.scss';

function Creations() {
  const [totalCount, setTotalCount] = useState(0);

  return (
    <div className="container-main">
      <div className="content-header">
        <div className="header-left">
          <Icon alias="creation-admin" width={24} height={24} color="#1a1a1a" />
          <h2>Creations [{totalCount.toLocaleString()}]</h2>
        </div>
        <p className="header-subtitle">Manage creations, monetisation and earnings</p>
      </div>
      <CreationTable onTotalCountChange={setTotalCount} />
    </div>
  );
}

export default Creations;
